import { AppRoutes } from "@/constants.ts";

/**
 * Return an internal-only redirect path, or null when the value is unsafe.
 */
export function safeLoginRedirectPath(raw: string | null): string | null {
  if (!raw) {
    return null;
  }
  const value = raw.trim();
  if (!value.startsWith("/") || value.startsWith("//")) {
    return null;
  }
  try {
    const parsed = new URL(value, window.location.origin);
    if (parsed.origin !== window.location.origin) {
      return null;
    }
    if (parsed.pathname === AppRoutes.login) {
      return null;
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return null;
  }
}

/**
 * Encode the current internal route for the login page's redirect query param.
 */
export function loginPathWithRedirect(currentPath: string): string {
  const redirectPath = safeLoginRedirectPath(currentPath);
  if (!redirectPath) {
    return AppRoutes.login;
  }
  return `${AppRoutes.login}?redirect=${encodeURIComponent(redirectPath)}`;
}
